import { IssuanceDocumentType } from './IssuanceDocument';

export const enum ProductType {
  LeaseFund = 1,
  DomesticRealEstate = 2,
  OverseasRealEstate = 3,
}

export const ProductTypeMap: {
  [P in ProductType]: { name: string; documentType: IssuanceDocumentType };
} = {
  [ProductType.LeaseFund]: {
    name: 'リースファンド',
    documentType: IssuanceDocumentType.LeaseFund,
  },
  [ProductType.DomesticRealEstate]: {
    name: '国内不動産',
    documentType: IssuanceDocumentType.DomesticRealEstate,
  },
  [ProductType.OverseasRealEstate]: {
    name: '海外不動産',
    documentType: IssuanceDocumentType.OverseasRealEstate,
  },
};
